'use client'

import { RevealText } from './reveal-text'

type PageIntroProps = {
  eyebrow: string
  title: React.ReactNode
  description?: string
}

export function PageIntro({ eyebrow, title, description }: PageIntroProps) {
  return (
    <div className="mb-16 md:mb-24 max-w-3xl">
      <RevealText>
        <span className="text-xs tracking-[0.3em] uppercase text-accent">{eyebrow}</span>
      </RevealText>
      <RevealText delay={0.1}>
        <h1 className="mt-4 font-serif text-4xl tracking-tight text-foreground md:text-6xl lg:text-7xl">
          {title}
        </h1>
      </RevealText>
      {description && (
        <RevealText delay={0.2}>
          <p className="mt-6 max-w-2xl font-serif text-xl italic leading-relaxed text-muted-foreground">
            {description}
          </p>
        </RevealText>
      )}
    </div>
  )
}
